import {
  ADVICE_PRICE_STEP,
  ADVICE_YOUR_LIFE_SITUATION_STEP,
} from "Components/Features/CheckPrice/Products/Advice";
import {
  AdviceProductDetailsBackendValues,
  AdviceProductDetailsFormValues,
  AkaCartAdviceValues,
  CartAdviceValues,
} from "Components/Features/CheckPrice/Products/Advice/ProductDetails/FormElements/interfaces";

import { AdvicePriceFormValues } from "Components/Features/CheckPrice/Products/Advice/ProductPrice/AdviceCards/interfaces";
import { ReduxState } from "Store/rootReducer";
import { AdviceState } from "./interfaces";

export const adviceSelector = (state: ReduxState): AdviceState => state.advice;

export const cartAdviceSelector = (
  state: ReduxState,
): CartAdviceValues | AkaCartAdviceValues | undefined =>
  state.cart?.current?.advice;

export const adviceProductValuesSelector = (
  state: ReduxState,
): AdviceProductDetailsBackendValues | undefined =>
  state.cart.current?.advice?.adviceProductValues;

export const adviceDetailsFormValuesSelector = (
  state: ReduxState,
): AdviceProductDetailsFormValues =>
  state.priceCalculation.priceCalculationFormStates[
    ADVICE_YOUR_LIFE_SITUATION_STEP.id
  ] as AdviceProductDetailsFormValues;

export const advicePriceFormValuesSelector = (
  state: ReduxState,
): AdvicePriceFormValues =>
  state.priceCalculation.priceCalculationFormStates[
    ADVICE_PRICE_STEP.id
  ] as AdvicePriceFormValues;
